export default "__VITE_ASSET__DAgl3PyU__"